import { Injectable } from '@angular/core';

import { environment } from '@environments/environment';

import { SessionService } from './session.service';
import Resources from '@constants/resourses';
@Injectable()
export class TealiumUtagService {
  scriptSrc = '';

  // Typically set "noview" flag (no first page automatic view event) to true for Single Page Apps (SPAs)
  constructor(
    private sessionService: SessionService
  ) {
    (window as any).utag_cfg_ovrd = (window as any).utag_cfg_ovrd || {};
    (window as any).utag_cfg_ovrd = { noview: true };
    (window as any).utag_data = {
      // app variables
      app_name: environment.tealium_app_name,
      app_version: environment.tealium_app_version,
      app_platform: environment.tealium_app_platform,

      // campaign variables
      // campaign_maskcode : "PL34"
    };
  }

  // Generic script loader with callback
  getScript(src: string, callback: () => void) {
    const d = document;
    const fn = () => { };
    const o = { callback: callback || fn };
    let s: any;
    let t: any;

    if (typeof src === 'undefined') {
      return;
    }

    s = d.createElement('script');
    // s.language = 'javascript';
    s.type = 'text/javascript';
    s.async = true;
    // s.charset = 'utf-8';
    s.src = src;

    if (typeof o.callback === 'function') {
      if (d.addEventListener) {
        s.addEventListener('load', () => { o.callback(); }, false);
      } else {
        // old IE support
        s.onreadystatechange = function () {
          if (this.readyState === 'complete' || this.readyState === 'loaded') { this.onreadystatechange = null; o.callback(); }
        };
      }
    }

    t = d.getElementsByTagName('script')[0];
    t.parentNode.insertBefore(s, t);
  }

  // Config settings used to build the path to the utag.js file
  setConfig(config: { account: string, profile: string, environment: string }) {
    if (config.account !== undefined && config.profile !== undefined && config.environment !== undefined) {
      this.scriptSrc = 'https://tags.tiqcdn.com/utag/' + config.account + '/' + config.profile + '/' + config.environment + '/utag.js';
    }
  }

  // Data layer is optional set of key/value pairs
  track(tealiumEvent: string, data?: any) {
    data.tealium_event = tealiumEvent;
    if (this.scriptSrc === '') {
      return;
    }

    // Reassigned new data value
    (window as any).utag_data = data;
    if (!(window as any).utag) {
      this.getScript(this.scriptSrc, () => {
        window['utag'].ut.merge(window['utag'].data, data, 1);
        window['utag'].track(tealiumEvent, data, () => {
        });
      });
    } else {
      // Merge the latest data with the existing Tealium data | JIG-1035 | 27 Feb 2024
      window['utag'].ut.merge(window['utag'].data, data, 1);
      // Track the Tealium event with the merged data
      window['utag'].track(tealiumEvent, window['utag'].data, () => { });

    }
  }

  /**
   * @description This method is used to track the view event
   * @param data - The data to be tracked
   */
  view(data?: any) {
    this.track('view', data);
  }

  /**
   * @description This method is used to track the link event
   * @param data - The data to be tracked
   */
  link(data?: any) {
    this.track('link', data);
  }

  /**
   * @description This new method is used to track the view event
   * @param data - The data to be tracked
   */
  viewEvent(data): void {
    data['event_action'] = '';
    data['event_category'] = '';
    data['event_label'] = '';
    data['tealium_event'] = 'view';

    // Tealium data stored in session storage
    this.sessionService.setItemIntoSession(Resources.SessionStorageKeys.TealiumData, data);

    this.track('view', data);
  }

  /**
   * @description This new method is used to track the link event
   * @param data - The data to be tracked
   */
  linkEvent(data): void {
    data['event_action'] = data['event_action'] ? data['event_action'] : 'onClick';
    data['event_category'] = data['event_category'] ? data?.app_name + '_' + data?.page_name + '_' + data?.event_category : data?.app_name + '_' + data?.page_name;
    data['event_label'] = data?.event_category + '_' + data?.event_label;
    data['tealium_event'] = 'link';

    // Tealium data stored in session storage
    this.sessionService.setItemIntoSession(Resources.SessionStorageKeys.TealiumData, data);

    this.track('link', data);
  }

  /**
   * @description This method is used to track the state of a field
   * @param state - The state of the field (focus/blur)
   * @param field - The name of the field
   * @param category - The category of the event
   * @param data - The data to be tracked
   */
  tealiumState(state: string, field: string, category: string, data: any): void {
    data['event_category'] = category ? category : '';
    // Focus on page state changes only
    if (state === 'focus') {
      data['event_action'] = 'onEntry';
      data['event_label'] = field + 'Entry';
    } else if (state === 'blur') {
      data['event_action'] = 'onExit';
      data['event_label'] = field + 'Exit';
    } else if (state === 'select') {
      data['event_action'] = 'onSelect';
      data['event_label'] = field + 'Select';
    }

    this.linkEvent(data);
  }
}
